<template>
  <div id="app" :class="['noselect','theme_'+appData.SETTINGS.theme_name]" :style="mainBackgroundStyle">
      

      <!-- base color, used for ds theme in product screen --> 
      <div class="baseSolidColorLayer"  :style="bgSolidStyle"></div>

    <!--
    <div class="modelLoadingFrame">
      <iframe src="models_preloader.html" />
    </div>
    -->    
    <!-- <div class="bgChanger" @click="changeBg"></div> -->
    <!-- <div class="__appScreenSize"> -->

    <!-- //////////////////////// 3D MODEL LAYER //////////////////////// -->
    <!-- 
        todo:
        when changing model we need to fade out the layer 
     -->     
    <div class="modelFrameLayer active" id="modelFrameWrapper1">
      <iframe class="iframeViewer" id="iframeModelViewer1" src="modelV5.html"></iframe>
    </div>


    <!-- //////////////////////// EDITOR //////////////////////// -->
     <div class="editorLayer" v-if="screenName == 'editor'">
      <editor></editor>
    </div>


    <!-- //////////////////////// APP LAYERS //////////////////////// -->
    <div class="appLayers" v-if="!preloadingModels">
      <waiting v-if="screenName == 'home'" @onClick="onWaitingClicked"></waiting>
      <menuscreen @onClick="onMenuClicked" v-if="screenName == 'menu'"></menuscreen>      
      <proscreen @onCloseProduct="onCloseProduct()" 
        v-if="screenName == 'product'" 
        :product_id="product_id"
        :product="index">
      </proscreen>      
    </div>

  </div>
</template>

<style>
  .baseSolidColorLayer
  {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 80;
    left: 0px;top: 0px;
    transition: all ease 0.4s;
    opacity: 0;
    background-color: #191e24;
  }



  .modelFrameLayer
  {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 100;
    left: 0px;top: 0px;
    transition: all ease 0.4s;
    opacity: 0;
  }
  .modelFrameLayer.active
  {
    opacity: 1;
  }
  .modelFrameLayer iframe
  {
      width: 100vw;
      height: 100vh;
      border: 0px;
  }
  .appLayers
  {
    position: fixed;
    z-index: 200;
    left: 0px;top: 0px;

  }
  .editorLayer
  {
    width: 100vw;height: 100vh;
    position: fixed;
    z-index: 2200;
    left: 0px;top: 0px;    
  }
</style>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Editor         from '@/editor/editor.vue' //last version
import WaitingScreen  from "@/views/WaitingScreen.vue";
import MenuScreen     from "@/views/MenuScreen.vue";
import ProductScreen  from "@/views/ProductScreen.vue";
import ViewPort       from "@/components/ViewPort.vue";
import ControlPanel   from "@/components/ControlPanel.vue";
import Model          from "@/components/Model.vue";
import Screen         from "@/components/Screen.vue";

export default {
  components: {
    editor:Editor,
    proscreen:ProductScreen,
    waiting:WaitingScreen,
    menuscreen:MenuScreen,
    viewport: ViewPort,
    panel: ControlPanel,
    model:Model,
    screen:Screen
  },
  data()
  {
    return{
      product_id:'',
      preloadingModels:true,
      screenName:'home', //home/menu/product
      index:0 ,
      bgIndex:1,
      inactivityTimeout:null
    }
  },
  computed:
  {
    ...mapState(["appData"]),
    bgSolidStyle()
    {
      if(
        this.screenName=="product" && 
        this.appData.SETTINGS.theme_name=="ds")
      {
        return "opacity:1";//show the grey bg 
      }else
      {
        return "opacity:0"; //show the base default bg image 
      }
        
    },
    mainBackgroundStyle()
    {
      //todo: get the background from the theme file
      //if(this.appData.SETTINGS.theme_name)
      if(this.appData.SETTINGS.theme_name=="ds")
      {
        //return "background-image: url('/images/bg-blue"+this.bgIndex+".jpg');";
        return "background-image: url('/images/bg-blue3.jpg');";
      }else
      {
        return "background-image: url('/images/bg-blue1.jpg');";
      }
      //if(this.screenName=="product")
      
    }
  },
  mounted()
  {
      //if url contains "editor" display the editor view
      if(window.location.href.includes('editor')){
        this.screenName = "editor";
      }
      this.loadAppData();
      if (window.addEventListener) {
          window.addEventListener("message", this.onMessage, false);        
      } 
      else if (window.attachEvent) {
          window.attachEvent("onmessage", this.onMessage, false);
      }
    //window.addEventListener('resize', this.onWindowResize);
    //this.setScreenHeight();

  },
  watch: {
    '$store.state.appThemeName': function() 
    {
      //alert(this.$store.state.appThemeName);
      //alert("appThemeName="+appThemeName);
      //this.loadAppTheme(this.appData.SETTINGS.theme_name);
    }
  },
  methods:
  {
    ...mapActions(["loadAppData","loadAppTheme"]),
    onWindowResize()
    {
      //this.setScreenHeight();
    },
    //const inactivityTime = 5000; // 5 seconds of inactivity
    initInactivityTimer() 
    {
      document.addEventListener("touchstart", this.resetInactivityTimer);
      document.addEventListener("touchend",   this.resetInactivityTimer);
      document.addEventListener("mousemove",  this.resetInactivityTimer);
      document.addEventListener("mousedown",  this.resetInactivityTimer);
      document.addEventListener("mouseup",    this.resetInactivityTimer);
      this.resetInactivityTimer();
    },
    resetInactivityTimer() 
    {
      //////////10000 = > 10 seconds
      const inactivityTime = 10000; // 10 seconds 
      //const inactivityTime = 600000; // 10 minutes 
      clearTimeout(this.inactivityTimeout);
      this.inactivityTimeout = setTimeout(this.handleInactive, inactivityTime);
    },
    handleInactive() {
      //alert("User is inactive!");

  //!important:
      //bug when user is wathcing a video he does not interact with the screen
      //so in this case the app will go back to the home opening page 

      /*
      //Remove 3d layer
      let iframeForModel = document.querySelector('#iframeModelViewer1');
      iframeForModel.style.display = 'none';
      iframeForModel.contentWindow.location.hash = "none";
      setTimeout(() => {
        iframeForModel.style.display = 'initial';
      }, 2000);

      //change screen mode to home 
      this.setNextScreen({name:"home",index:0});
      */
    },
    
    onMessage(event) 
    {
        console.log("msg received");
        var data = event.data;
        console.log("data.message="+data.message);
        if(data.message=='preloading_complete')
        {
            //alert("init initInactivityTimer");
            this.preloadingModels = false;
            this.initInactivityTimer();
        }                
    },    
    changeBg()
    {
      let bgsCount = 2;
      this.bgIndex++;
      if(this.bgIndex>bgsCount)
      {
        this.bgIndex=1;
      }
    },
    setNextScreen(sd)
    {
      //this.screenData = sd;
      this.screenName = sd.name;
      this.index = sd.index;
      this.product_id = sd.product_id;
      //alert("screenData.name="+this.screenData.name);
    },
    onWaitingClicked()
    {
      //hide the waiting screen and open the main menu
      this.setNextScreen(
          {name:"menu",index:0,product_id:''}
      );
    },
    onMenuClicked(index,name)
    {
      //alert("name="+name+ " index="+index);
      this.setNextScreen(
          {name:"product",index:index,product_id:name}
      );
    },
    onCloseProduct()
    {
      this.setNextScreen(
          {name:"menu",index:0,product_id:''}
      );
    },
    getScaleStyle()
    {
      var scaleCss = "transform:scale(0.3,0.3);";
      return scaleCss;
    }
  }
};
</script>

<style>

@font-face {
    font-family: 'Montserrat';
    src: url('/fonts/Montserrat/Montserrat-VariableFont_wght.woff2') format('woff2'),
     url('/fonts/Montserrat/Montserrat-VariableFont_wght.woff') format('woff'),
     url('/fonts/Montserrat/Montserrat-VariableFont_wght.ttf') format('truetype');    
    font-weight: 100 900;
    font-style: normal;
}      

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #111111;
  font-family: 'Montserrat';
}
body {
  margin: 0px;
}

/* * {
  font-family: 'Montserrat' !important;
}
 */



.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}


canvas {
  position: relative;
}
#app {
  height: 100%;  
  background-position: center center;
  background-size: cover;
}
  :root{
    --appWidth : 3480px;
    --appHeight : 2160px;
    --appRatio :1.611;/* calc(calc(var(--appWidth)/var(--appHeight))); */
  }

/* DS Theme specific styles */
#app.theme_ds
{
    /* background-image: none !important; */    
    background-size: cover;
    background-position: center center;
}

.modelLoadingFrame
{
  position: fixed;
  top: 0px;
  left: 0px;
}

.appScreenSize
{
  width:100vw; /* calc(100vh * var(--appRatio)); */
  height: 100vh;
  margin: auto;
}

.modelLayer
{
  position: fixed;
  display: block;
  top: 0px;
  left: 0px;
  z-index: 111;
}
.appDebug
{
  position: fixed;
  display: block;
  top: 10px;
  left: 10px;
  background-color: rebeccapurple;
  color: #fff;
  z-index: 111;
  padding: 20px;
  font-size: 11px;
}
.bgChanger
{
  position: fixed;
  z-index: 1000000;
  bottom: 0px;
  left: 0px;
  width: 100px;
  height: 100px;
  background-color: transparent;
}
</style>
